<template>
  <div class>
    <!-- header start -->
    <van-nav-bar
      title="祭拜记录"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
        <div v-for="item in dataList" :key="item.SerialNumber">
          <div class="gift-record-list van-hairline--bottom">
            <div class="hd">
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                :src="item.AppSacrifice.CoverPhotoPath"
              />
            </div>
            <div class="bd">
              <div class="name">{{item.NickName}}</div>
              <span class="tag">{{item.AppSacrifice.SacrificeName}}</span>
            </div>
            <div class="ft">
              <span v-if="item.IsExpired == false" class="status active">点亮中</span>
              <span v-else class="status">已结束</span>
              <p class="date">{{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</p>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <!-- <div>
      <div class="gift-record-list van-hairline--bottom">
        <div class="hd">
          <van-image
            width="100%"
            height="100%"
            fit="cover"
            src="http://img2.huaien.com/jinian/material/j03/j03_t_01.png"
          />
        </div>
        <div class="bd">
          <div class="name">佳佳</div>
          <span class="tag">菊花(1)</span>
        </div>
        <div class="ft">
          <span v-if="item == 1" class="status active">点亮中</span>
          <span v-else class="status">已结束</span>
          <p class="date">01月14日</p>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      uid: "",
      id: 0,
      placeType: 0,
      keyName: "",
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: []
    };
  },
  components: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    init() {
      var that = this;
      this.options = {
        type: "GetSacrificeLogSearchList",
        KeyName: that.keyName,
        MemorialHallID: that.uid,
        PlaceType: that.placeType,
        pageIndex: 1
      };
      this.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.SacrificeLogList;
          if (dataList.length <= 0) {
            that.finished = true;
          }
          if (dataList.length < 10) {
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = dataList;
          }
        },
        error => {}
      );
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.uid = this.$route.query.uid;
    this.keyName = this.$route.query.KeyName;
    this.placeType = this.$route.query.placeType;
    this.init();
  }
};
</script>

<style scoped>
.gift-record-list {
  display: flex;
  align-items: center;
  padding: 15px;
}
.gift-record-list > .hd {
  width: 58px;
  height: 58px;
  margin-right: 10px;
}
.gift-record-list > .bd {
  flex: 1;
  overflow: hidden;
}
.gift-record-list > .bd > .name {
  font-weight: normal;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gift-record-list > .bd > .tag {
  font-size: 12px;
  height: 24px;
  line-height: 24px;
  padding: 0 10px;
  background-color: #f60;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  margin-top: 4px;
}
.gift-record-list > .ft {
  text-align: right;
  margin-left: 15px;
}
.gift-record-list > .ft > .status {
  font-size: 14px;
  color: #999;
}
.gift-record-list > .ft > .status.active {
  color: #f60;
}
.gift-record-list > .ft > .date {
  font-size: 12px;
  color: #bbb;
  margin-top: 10px;
}
</style>
